import styled from 'styled-components';

export const StyledTransactionTile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }): string => theme.spacing_unit_x2};
  margin: ${({ theme }): string => `${theme.spacing_unit_x1} 0`};
  border: ${({ theme }): string => {
    return `1px solid ${theme.palette_gray_5}`;
  }};
  border-radius: ${({ theme }): string => theme.border_radius_x1};
`;

export const StyledFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
